import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import React, { useState } from "react";
import SingleChoiceV2WithoutSubmit from "../../components/singleChoiceV2WithoutSubmit";
import { useTranslation } from "react-i18next";

//TODO: Rename since it is a general component
function SingleChoiceStep({
  initState = null,
  onSubmitHandler,
  qKey,
  question,
  questionCode,
  choices,
  pageTitle,
  nextConfig = null,
  hideLibrary = false,
}) {
  const { previousStep, nextStep, goToStep } = useWizard();
  const [selectedChoice, setSelectedChoice] = useState(
    initState && initState["selectedChoiceInit"]
      ? initState["selectedChoiceInit"]
      : { value: null, text: null, id: null }
  );
  const { t } = useTranslation();

  const onOptionChange = (choiceInfo) => {
    setSelectedChoice(choiceInfo);
  };

  const next = () => {
    let response = {
      _state: {
        selectedChoiceInit: selectedChoice,
      },
      formatted_response: {
        type: "RADIO",
        question: question,
        code: questionCode,
        choices: [
          {
            text: selectedChoice.text,
            correct: true,
            code: selectedChoice.id,
          },
        ],
      },
    };
    onSubmitHandler({ [qKey]: response });
    return toJumpStep(selectedChoice)
      ? goToStep(nextConfig["nextStep"])
      : nextStep();
  };

  const toJumpStep = (choice) => {
    if (nextConfig == null) return false;
    return choice.id == nextConfig["optionCode"];
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={pageTitle}
        hideLibrary={hideLibrary}
      />
      <div className="body_content">
        <div className="inner_body">
          <SingleChoiceV2WithoutSubmit
            question={question}
            choices={choices}
            qKey={qKey}
            selectedChoice={selectedChoice}
            onChange={onOptionChange}
          />
        </div>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            disabled={selectedChoice.value == null}
            onClick={() => next()}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </>
  );
}

export default SingleChoiceStep;
